(function() {
  const params = new URLSearchParams(window.location.search);
  const fbclid = params.get('fbclid');
  if (!fbclid) return;

  const origin = location.origin;

  function appendFbclid(href) {
    try {
      if (!href || href.startsWith('#')) return href;
      const scheme = href.split(':')[0].toLowerCase();
      if (['mailto', 'tel', 'javascript', 'data'].includes(scheme)) return href;

      const url = new URL(href, location.href);

      // Skip external URLs (different origin)
      if (url.origin !== origin) return href;

      // Skip pure in-page anchor (same path/search, only hash differs)
      const currentNoHash = location.href.split('#')[0];
      const candidateNoHash = url.href.split('#')[0];
      if (candidateNoHash === currentNoHash) return href;

      if (url.searchParams.has('fbclid')) return href;

      url.searchParams.set('fbclid', fbclid);

      // Preserve relative form for relative inputs
      if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(href)) {
        return url.href;
      } else {
        return url.href.replace(url.origin, '');
      }
    } catch (e) {
      return href;
    }
  }

  document.querySelectorAll('a[href]').forEach(a => {
    const original = a.getAttribute('href');
    if (!original || original.startsWith('#')) return;
    const updated = appendFbclid(original);
    if (updated !== original) a.setAttribute('href', updated);
  });
})();
